<template>
  <div class="nk-body body-wider bg-light-alt">
    <div class="nk-wrap">
      <header class="nk-header page-header is-transparent is-sticky is-shrink" id="header">
        <div class="header-main inner-header">
          <HeaderTerms />
        </div>      
        <HeaderBanner >
          <h2 class="title ttu" slot="banner-title">Terms Of Sales</h2>                               
        </HeaderBanner>    
      </header>
      <TermsBody />
      <Footer />
    </div>
  </div>
</template>

<script>
import HeaderBanner from '@/components/HeaderBanner'
import Footer from '@/components/Footer'
import TermsBody from '@/components/TermsBody'
import HeaderTerms from '@/components/HeaderTerms'

export default {
  name: 'Terms',
  components: {
    HeaderBanner,
    Footer,
    TermsBody,
    HeaderTerms
  }
}
</script>

<style>

</style>
